module.exports = __webpack_public_path__ + "static/media/man_file.b9198251.svg";